export enum ScanType {
  InternalPentest = 0,
  ExternalPentest = 1,
  WebsiteScan = 2,
}

export namespace ScanType {
  export function mapFromApiValue(scanType: string): ScanType {
    const scanTypes: Record<string, ScanType> = {
      ['INTERNAL_PENTEST']: ScanType.InternalPentest,
      ['EXTERNAL_PENTEST']: ScanType.ExternalPentest,
      ['WEBSITE_SCAN']: ScanType.WebsiteScan,
    };
    return scanTypes[scanType];
  }

  export function mapToApiValue(scanType: ScanType): string {
    const scanTypes: Record<ScanType, string> = {
      [ScanType.InternalPentest]: 'INTERNAL_PENTEST',
      [ScanType.ExternalPentest]: 'EXTERNAL_PENTEST',
      [ScanType.WebsiteScan]: 'WEBSITE_SCAN',
    };
    return scanTypes[scanType];
  }
}
